import { gql } from '@apollo/client';

const CartInfoPublic = gql`
  fragment CartInfoPublic on Cart {
    id
    state
    subtotal
    discountId
    discountAmount
    taxAmount
    shippingAmount
    total
    updatedAt
    currency
    hexCode
    cartItemsAttributes {
      id
      name
      price
      discountId
      discountAmount
      taxAmount
      shippingAmount
      total
      quantity
      patientId
      patient {
        id
        firstName
        lastName
      }
      productId
      product {
        id
        name
        featuredImage
        description
        isRetainer
        productType
        planStartInterval
        productFeatures {
          id
          text
        }
        planSubscription {
          id
          name
          price
          renewalIntervalMonths
          featuredImage
          description
          productFeatures {
            id
            text
          }
        }
        planProducts {
          id
          price
          overridePrice
          assignedProduct {
            id
            name
            featuredImage
            price
            description
            productFeatures {
              id
              text
            }
          }
        }
      }
    }
  }
`;

export default CartInfoPublic;
